<template>
  <div class="container">
    <Buttons />
    <h5 class="title">{{ title }}</h5>

    <div class="row-button" v-if="!readOnly">
      <Moda />
      <div class="btn-direction-flex">
        <b-button
          pill
          variant="primary"
          class="btn-one"
          @click="guardarBorrador"
          v-if="userPermissions"
        >
          Guardar como borrador
        </b-button>
        <b-button
          pill
          variant="primary"
          class="btn-two"
          @click="guardarFinalizado"
          v-if="userPermission"
        >
          Guardar y finalizar
        </b-button>
      </div>
      <div></div>
    </div>
    <List
      :readOnly="readOnly"
      :addItemList="addItemList"
      :itemList="itemList"
      :removeItem="removeItem"
    />
  </div>
</template>
<script>
import List from "./Tabla/List";
import Buttons from "./Buttons.vue";
import Moda from "../../presentacion-servicio/components/else/Moda.vue";
import Swal from "sweetalert2";
import axios from "axios";
import { showAlert } from "@/components/tools/utils";

export default {
  components: {
    List,
    Buttons,
    Moda,
  },
  data() {
    return {
      itemList: [],
      anio: process.env.VUE_APP_ANIO,
      nombre: "servicios_c",
      arrayButton: [],
      buttonViews: false,
      dataViews: null,
      datosUser: null,
    };
  },
  props: ["readOnly", "title", "userPermissions", "userPermission"],

  methods: {
    addItemList: function() {
      const toAddObj = {
        cargo: "",
        nombre: "",
      };
      this.itemList.push(toAddObj);
    },
    removeItem: function(index) {
      const pos = this.itemList.indexOf(index);

      this.itemList.splice(pos, 1);
    },
    buildData: function(type) {
      return {
        nombre: this.nombre,
        elaboracion: type,
        data: {
          content: this.itemList,
        },
        anio: process.env.VUE_APP_ANIO,
        idServicio: this.$route.params.idServicio,
      };
    },
    guardarBorrador: async function() {
      const toSend = this.buildData("borrador");
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
          toSend,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        showAlert({
          icon: "success",
          text: "Guardado como Borrador Exitoso",
          timerProgressBar: true,
          timer: 3000,
        });
        console.log(res);
      } catch (error) {
        if (error.response.status === 422) {
          const toSend = {
            nombre: this.nombre,
            elaboracion: "borrador",
            data: {
              content: this.itemList,
            },
            anio: process.env.VUE_APP_ANIO,
          };

          await axios.put(
            `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
            toSend,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          );

          showAlert({
            icon: "success",
            text: "Guardado como Borrador Exitoso",
            timerProgressBar: true,
            timer: 3000,
          });
        } else {
          console.log(error);
          showAlert({
            icon: "error",
            text: error.response.data[Object.keys(error.response.data)[0]],
            timerProgressBar: true,
            timer: 3000,
          });
        }
        console.log(error);
      }
    },
    guardarFinalizado: async function() {
      const toSend = this.buildData("finalizado");

      Swal.fire({
        title: "Guardar y Finalizar",
        text: "¿Desea guardar los datos?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await axios.post(
              `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
              toSend,
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );
            showAlert({
              icon: "success",
              text: "Guardado y finalizado exitosamente.",
              timerProgressBar: true,
              timer: 3000,
            });
            console.log(res);
          } catch (error) {
            if (error.response.status === 422) {
              const toSend = {
                nombre: this.nombre,
                elaboracion: "finalizado",
                data: {
                  content: this.itemList,
                },
                anio: process.env.VUE_APP_ANIO,
              };

              await axios.put(
                `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
                toSend,
                {
                  headers: {
                    Authorization: `JWT ${localStorage.getItem("userToken")}`,
                  },
                }
              );

              showAlert({
                icon: "success",
                text: "Documento Guardado ",
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              console.log(error);
              showAlert({
                icon: "error",
                text: error.response.data[Object.keys(error.response.data)[0]],
                timerProgressBar: true,
                timer: 3000,
              });
            }
            console.log(error);
          }
          this.$router.push({
            name: "buttons",
            params: { idUsuario: this.usuario.id },
          });
        }
      });
    },
    obtenerContenido: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${this.anio}&nombre=${this.nombre}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        if (res.data.info.content) {
          this.itemList = res.data.info.content;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.obtenerContenido();
    this.obtenerRelacionUsuarioServicio();
  },
};
</script>
<style scoped>
.title {
  margin: 25px 0;
  font-weight: bold;
  text-align: center;
}
.btn-one {
  margin-right: 20px;
}

.btn-direction-flex {
  text-align: end;
}
.row-button {
  display: flex;
  justify-content: space-between;
  margin: 25px 0;
}

@media screen and (max-width: 784px) {
  .btn-one {
    font-size: 11px;
    margin-right: 5px;
  }
  .btn-two {
    font-size: 11px;
  }
}

@media screen and (max-width: 569px) {
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
  }
}

@media screen and (max-width: 417px) {
  .one {
    display: none;
  }
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
    margin-bottom: 15px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
    position: relative;
    top: -6px;
  }
  .btn-direction-flex {
    text-align: start;
    margin-left: 30px;
  }
}
</style>
